module.exports = __webpack_public_path__ + "img/login.bfe521f6.svg";